module.exports = __webpack_public_path__ + "img/arrow-sidebar-right.af6e12c2.svg";